import {
  FETCH_ORGANIZATIONS,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_TAXONOMY_SUCCESS,
  UPDATE_ORGANISATION,
  UPDATE_ORGANISATION_SUCCESS,
  UPDATE_ORGANISATION_FAIL,
  UPDATE_MOBILE_APP,
  UPDATE_MOBILE_APP_SUCCESS,
  UPDATE_MOBILE_APP_FAIL,
  FETCH_PHYSICAL_ORGANIZATIONS,
  FETCH_PHYSICAL_ORGANIZATIONS_SUCCESS,
  FETCH_PHYSICAL_ORGANIZATIONS_FAIL,
  UPDATE_PHYSICAL_ORGANISATION,
  UPDATE_PHYSICAL_ORGANISATION_SUCCESS,
  UPDATE_PHYSICAL_ORGANISATION_FAIL,
  FETCH_POIS,
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAIL,
  FETCH_ORGANIZATION_BY_ID,
  FETCH_ORGANIZATION_BY_ID_SUCCESS,
  FETCH_ORGANIZATION_BY_ID_FAIL
} from "../constants";

const initialState = {
  organizationsList: [],
  organizationsListLoaded: true,
  taxonomyList: [],
  updatedOne: {},
  isUpdating: false,
  mobileAppList: [],
  willUpdateMobileApp: {},
  physicalOrganizationsList: [],
  physicalOrganizationsListLoaded: true,
  physicalOrganizationsError: null,
  updatedPhysicalOne: {},
  isUpdatingPhysical: false,
  poisList: [],
  poisListLoaded: true,
  poisError: null,
  organizationDetails: null,
  organizationDetailsLoaded: true,
  organizationDetailsError: null,
};

const organizationsConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGANIZATIONS:
      return {
        ...state,
        organizationsListLoaded: false
      };
    case FETCH_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizationsList: action.data,
        organizationsListLoaded: true
      };
    case FETCH_TAXONOMY_SUCCESS:
      return {
        ...state,
        taxonomyList: action.data
      };
    case UPDATE_ORGANISATION:
      return {
        ...state,
        isUpdating: true
      };
    case UPDATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        updatedOne: action.data,
        isUpdating: false
      };
    case UPDATE_ORGANISATION_FAIL:
      return {
        ...state,
        isUpdating: false
      };
    case UPDATE_MOBILE_APP:
      return {
        ...state,
        isUpdating: true
      };
    case UPDATE_MOBILE_APP_SUCCESS:
      return {
        ...state,
        willUpdateMobileApp: action.data,
        isUpdating: false
      };
    case UPDATE_MOBILE_APP_FAIL:
      return {
        ...state,
        isUpdating: false
      };
    case FETCH_PHYSICAL_ORGANIZATIONS:
      return {
        ...state,
        physicalOrganizationsListLoaded: false
      };
    case FETCH_PHYSICAL_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        physicalOrganizationsList: action.data,
        physicalOrganizationsListLoaded: true,
        physicalOrganizationsError: null
      };
    case FETCH_PHYSICAL_ORGANIZATIONS_FAIL:
      return {
        ...state,
        physicalOrganizationsList: [],
        physicalOrganizationsListLoaded: true,
        physicalOrganizationsError: action.error
      };
    case UPDATE_PHYSICAL_ORGANISATION:
      return {
        ...state,
        isUpdatingPhysical: true
      };
    case UPDATE_PHYSICAL_ORGANISATION_SUCCESS:
      return {
        ...state,
        updatedPhysicalOne: action.data,
        isUpdatingPhysical: false
      };
    case UPDATE_PHYSICAL_ORGANISATION_FAIL:
      return {
        ...state,
        isUpdatingPhysical: false
      };
    case FETCH_POIS:
      return {
        ...state,
        poisListLoaded: false
      };
    case FETCH_POIS_SUCCESS:
      return {
        ...state,
        poisList: action.data,
        poisListLoaded: true,
        poisError: null
      };
    case FETCH_POIS_FAIL:
      return {
        ...state,
        poisList: [],
        poisListLoaded: true,
        poisError: action.error
      };
    case FETCH_ORGANIZATION_BY_ID:
      return {
        ...state,
        organizationDetailsLoaded: false
      };
    case FETCH_ORGANIZATION_BY_ID_SUCCESS:
      return {
        ...state,
        organizationDetails: action.data,
        organizationDetailsLoaded: true,
        organizationDetailsError: null
      };
    case FETCH_ORGANIZATION_BY_ID_FAIL:
      return {
        ...state,
        organizationDetails: null,
        organizationDetailsLoaded: true,
        organizationDetailsError: action.error
      };
    default:
      return state;
  }
};

export default organizationsConfiguration;
